// React
import React, { useState } from 'react'

import { useNavigate } from 'react-router-dom'

// Appt
import Anchor from '../../simple/anchor/Anchor.js'
import Box from '../../simple/box/Box.js'
import Form from '../../simple/form/Form.js'
import FormField from '../../simple/formField/FormField.js'
import Text from '../../simple/text/Text.js'
import TextInput from '../../simple/input/TextInput.js'
import ActionButton from '../actionButton/ActionButton.js'
import CheckBox from '../../simple/input/CheckBox.js'

/**
 * `UserVerification` renders a UserVerification screen
 */
function UserVerification (props) {
  const navigate = useNavigate()

  const [code, setCode] = useState({
    verificationCode: ''
  })

  const [rememberDevice, setRememberDevice] = useState(false)

  const handleBackClick = () => navigate('/login')

  const handleCodeChange = (code) => {
    setCode(code)
  }

  const onSubmit = () => {
    props.handleVerificationCode(code.verificationCode, rememberDevice)
  }

  return (
    <>
      <Box align='center' animation='fadeIn' alignSelf='center' width='medium'>
        <Box width='medium'>
          <Text color={props.labelColor} margin={{ top: 'medium', bottom: 'medium' }} textAlign='start' weight='bold' size='26px'>Login Verification</Text>
        </Box>

        <Box width='medium'>
          <Form
            onChange={nextValue => {
              handleCodeChange(nextValue)
            }}
            onSubmit={() => onSubmit()}
            value={code}
          >
            <Text color='white' size='small'>Welcome back. For your security, we’ve sent a Behaviour Smart code to your inbox. Enter it below to continue.</Text>

            <FormField margin={{ vertical: 'small' }} name='verificationCode' required>
              <TextInput name='verificationCode' placeholder='Enter verification code' />
            </FormField>

            <FormField margin={{ top: 'small', bottom: 'large' }} name='rememberDevice'>
              <Box direction='row' align='start' gap='small'>
                <CheckBox
                  checked={rememberDevice}
                  label={<Text color='white'><Text color='white' weight='bold'>Trust this device for 8 hours</Text> - you will not be asked for a verification code again during this period.</Text>}
                  onChange={() => setRememberDevice(!rememberDevice)}
                />
              </Box>
            </FormField>

            <ActionButton fill='horizontal' label='Verify' primary type='submit' />

            <Box direction='row' justify='between' margin={{ top: 'medium' }}>
              <Anchor color='white' onClick={() => handleBackClick()} size='xsmall' label='< Back to login' />
            </Box>
          </Form>
        </Box>
      </Box>
    </>)
}

export default UserVerification
